import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationComponent } from './components/application/application.component';
import { LandingComponent } from './components/landing/landing.component';
import { TermsComponent } from './components/terms/terms.component';
import { UnsubscribedComponent } from './components/unsubscribed/unsubscribed.component';
import { CompletedComponent } from './components/completed/completed.component';

const routes: Routes = [
  { path: '', component: LandingComponent },                  // Home
  { path: 'apply', component: ApplicationComponent },         // /apply
  { path: 'apply/:unique_id', component: ApplicationComponent }, // /apply/:unique_id
  { path: 'institution/:unique_id', component: ApplicationComponent }, // /institution/:unique_id
  { path: 'terms-and-conditions', component: TermsComponent },
  { path: 'unsubscribed', component: UnsubscribedComponent },
  { path: 'completed/:lead_id', component: CompletedComponent },
  { path: 'completed', component: CompletedComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' },          // catch-all
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
